import script from "./Clients.vue?vue&type=script&setup=true&lang=js"
export * from "./Clients.vue?vue&type=script&setup=true&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=ceaf240c&lang=scss"

const __exports__ = script;

export default __exports__